import { Dispatch, SetStateAction } from "react";
import { IButtonItemProps } from "@evergis/ui";
import { LayerInfo } from "../../../interfaces/resourceInfo";

import { EXPORT_FILE_TYPES } from "./constants";

export interface TitleProps {
  cancelExport: VoidFunction;
}

export interface ActionsProps {
  submit: VoidFunction;
  cancel: VoidFunction;
  loading: boolean;
}

export type ExportDialogContentProps = {
  layer: LayerInfo;
  isLoading?: boolean;
  isPointData: boolean;
  description?: string;
  selectedFormat?: IButtonItemProps;
  setSelectedFormat?: Dispatch<SetStateAction<IButtonItemProps>>;
  isWkt: boolean;
  setIsWkt: (value: boolean) => void;
  columnDelimiter: string;
  setColumnDelimiter: (value: string) => void;
};

export type ExportFormat = typeof EXPORT_FILE_TYPES[number]["name"];

export enum ExportType {
  Shape = "Shape",
  GeoJSON = "GeoJSON",
  Csv = "Csv",
  Excel = "XLSX",
}
